module.exports = __webpack_public_path__ + "img/nointernet.703dd7bb.jpeg";